export default __webpack_public_path__ + "1576bc47e423605a913c0d1a71ce424f.png";